<template>
  <div id="app">
    <Header/>
    <Home :account-id="accountId" :page-size="pageSize" :template-id="templateId" :include-past="includePast"
          :only-past="onlyPast"/>
    <Footer/>
  </div>
</template>


<script>

import Header from './Header'
import Footer from './Footer'
import Home from '../../views/Home.vue'

export default {
  props: {
    accountId: {
      type: String
    },
    pageSize: {
      type: Number
    },
    templateId: {
      type: Number
    },
    includePast: {
      type: Boolean
    },
    onlyPast: {
      type: Boolean
    },
  },
  components: {
    Header,
    Footer,
    Home
  }
}

</script>
